import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import './index.css'
import App from './App'
import { scrollWindowToTop } from './utils/scrollToTop'

if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual'
}

scrollWindowToTop()

const root = createRoot(document.getElementById('root'))

root.render(
  <StrictMode>
    <App />
  </StrictMode>,
)
